import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const WorkshopPreview = () => {
  const workshops = [
    {
      date: 'Mar 15',
      title: 'Advanced Problem Recognition Seminar',
      time: '2:00 PM - 5:00 PM EST',
      spots: '3 spots left',
      price: '$2,500',
      icon: 'ri-search-eye-line',
    },
    {
      date: 'Mar 22',
      title: 'Problem Escalation Masterclass',
      time: '10:00 AM - 4:00 PM EST',
      spots: '5 spots left',
      price: '$3,200',
      icon: 'ri-alarm-warning-line',
    },
    {
      date: 'Apr 5',
      title: 'Maintaining Problem Awareness Workshop',
      time: '1:00 PM - 6:00 PM EST',
      spots: 'Sold Out',
      price: '$2,800',
      icon: 'ri-eye-line',
    },
  ];

  return (
    <section className="relative py-32 bg-black overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fa41a3adcf9242948f6dec9450bec9c7.jpg"
          alt="Peaceful lake at sunset"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/75"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
            Educational Programs
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
            Upcoming Problem Workshops
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto">
            Exclusive training sessions to enhance your problem identification capabilities
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {workshops.map((workshop, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-dark-gray/80 backdrop-blur-sm rounded-2xl p-8 border border-gold/20 hover:border-gold/40 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-gold/10">
                  <i className={`${workshop.icon} text-3xl text-gold`}></i>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-black text-white">
                    {workshop.date}
                  </div>
                  <div className="text-sm text-light-gray">2024</div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4 leading-tight">
                {workshop.title}
              </h3>

              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-3 text-light-gray">
                  <i className="ri-time-line text-gold"></i>
                  <span className="text-sm">{workshop.time}</span>
                </div>
                <div className="flex items-center gap-3 text-light-gray">
                  <i className="ri-group-line text-gold"></i>
                  <span className="text-sm">{workshop.spots}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-price-tag-3-line text-gold"></i>
                  <span className="text-xl font-bold text-white">
                    {workshop.price}
                  </span>
                </div>
              </div>

              <button
                className={`w-full py-4 rounded-full text-base font-bold transition-all duration-300 whitespace-nowrap ${
                  workshop.spots === 'Sold Out'
                    ? 'bg-dark-gray/50 text-light-gray/50 cursor-not-allowed'
                    : 'bg-gold text-black hover:bg-white'
                }`}
                disabled={workshop.spots === 'Sold Out'}
              >
                {workshop.spots === 'Sold Out' ? 'Sold Out' : 'Reserve Your Spot'}
              </button>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <Link
            to="/financial-success"
            className="inline-flex items-center gap-3 border-2 border-cream/50 text-cream px-8 py-4 rounded-full text-base font-bold hover:bg-cream hover:text-black transition-all duration-300 whitespace-nowrap"
          >
            View Full Workshop Calendar
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default WorkshopPreview;